import React from 'react';
import { HomeIcon, CalendarIcon, UserIcon } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const navItems = [{
    path: '/home',
    icon: HomeIcon,
    label: 'Venues'
  }, {
    path: '/bookings',
    icon: CalendarIcon,
    label: 'My Bookings'
  }, {
    path: '/profile',
    icon: UserIcon,
    label: 'Profile'
  }];
  return <nav className="bg-[#1f5070] border-t border-[#1f5070]/20" style={{
    height: '60px'
  }} data-id="element-64">
      <div className="flex justify-around items-center h-full" data-id="element-65">
        {navItems.map(({
        path,
        icon: Icon,
        label
      }) => {
        const isActive = location.pathname === path || location.pathname.startsWith(path);
        return <button key={path} onClick={() => navigate(path)} className={`flex flex-col items-center justify-center gap-1 px-6 py-2 transition-all ${isActive ? 'text-[#c7f61e]' : 'text-white/60'}`} data-id="element-66">
              <Icon className={`w-6 h-6 ${isActive ? 'stroke-[2.5]' : 'stroke-2'}`} data-id="element-67" />
              <span className={`text-xs ${isActive ? 'font-bold' : 'font-medium'}`} data-id="element-68">
                {label}
              </span>
            </button>;
      })}
      </div>
    </nav>;
}